exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".correction-form{\r\n    min-height: 360px;\r\n    width: 500px;\r\n    border: 1px solid #e0e0e0; \r\n    border-radius: 5px;\r\n    padding:10px 10px;\r\n    background: white;\r\n}\r\n.outer-div{\r\n    padding: 20px 20px;\r\n    background: #e0e0e0;\r\n}\r\n.outer-div form div div{\r\n    margin-bottom: 3px;\r\n    color: #666768;\r\n}\r\n.outer-div form div div label{\r\n    font-size: 13px;\r\n    color: #666768;\r\n}\r\ntable tr td button{\r\n    background: white;\r\n    padding: 2px 20px;\r\n    border: 1px solid #666768; \r\n    color: #666768;\r\n    transition: 0.3ms;\r\n}\r\ntable tr td button:hover{\r\n    background: #666768;\r\n    color: white;\r\n    border: none;\r\n}\r\n.heading-div{\r\n    padding:1px 20px;\r\n    background: #e0e0e0;\r\n    margin-bottom: 5px;\r\n    font-weight: 600;\r\n    font-size: 15px; \r\n    color: #666768;\r\n}\r\n.sub-heading-div{\r\n    padding:1px 20px;\r\n    margin-bottom: 5px;\r\n    color: #666768;\r\n    font-size: 13px;\r\n}\r\n.errorClass{\r\n    color: red;\r\n    font-size: 13px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/correction/correction.component.css
// module id = 463
// module chunks = 1